// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.dialog-title-bar {
  padding: 20px 24px 4px;
}
.dialog-title-bar h2 {
  margin: 0;
  text-transform: lowercase;
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 28px;
  line-height: 1.1;
  font-weight: 700;
  text-align: center;
}

.progress-bar-container {
  min-height: 4px;
  padding: 0 24px;
}
.progress-bar-container .searching-progress-bar {
  height: 4px;
}

.dialog-body {
  padding: 8px 24px 0 !important;
}

.content-layout {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-height: 50vh;
}

.filters-column {
  width: 260px;
  max-height: 60vh;
  overflow-y: auto;
  background: #f7f9fc;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  padding: 8px;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.filter-header h6 {
  margin: 0;
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 16px;
  line-height: 1;
  text-transform: lowercase;
}

.filter-group-heading {
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #0b2d71;
  padding: 8px 0 2px;
  border-bottom: 1px solid #e3e3e3;
  margin-bottom: 2px;
}

.clear-all-btn {
  border: 1px solid #0066b2;
  background: white;
  color: #0066b2;
  cursor: pointer;
  height: 28px;
  padding: 0 8px;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 12px;
}

.table-column {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.table-top-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
}

.active-filter-chips {
  margin: 4px 0 2px;
  position: relative;
  z-index: 2;
  pointer-events: auto;
}
.active-filter-chips .chip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 280px;
  display: inline-block;
}
.active-filter-chips .chip-remove-btn {
  border: 0;
  background: transparent;
  width: 22px;
  height: 22px;
  min-width: 22px;
  padding: 0;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  pointer-events: auto;
  position: relative;
  z-index: 3;
}
.active-filter-chips .chip-remove-btn mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}

.search-input-wrapper {
  flex: 1;
}

.selected-count {
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 14px;
  line-height: 1;
  margin: 4px 0 2px;
  text-transform: lowercase;
}

.results-panel {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  overflow: hidden;
  background: white;
}

.table-scroll-container {
  overflow: auto;
  min-height: 0;
  flex: 1;
}

.release-candidates-table {
  width: 100%;
  min-width: 1450px;
}

.release-candidates-table .mat-mdc-header-row {
  background: #f3f6fa;
}

.release-candidates-table .mat-mdc-header-cell {
  color: #000000;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 13px;
  line-height: 1;
  padding: 8px 8px;
  border-bottom: 1px solid #e3e3e3;
  text-transform: lowercase;
  font-weight: 600;
  white-space: nowrap;
}

.release-candidates-table .mat-mdc-cell {
  padding: 7px 8px;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 13px;
  line-height: 1.1;
  border-bottom: 1px solid #e7ebf0;
  white-space: nowrap;
}

.release-candidates-table .mat-mdc-row:nth-child(even) .mat-mdc-cell {
  background: #fbfcfe;
}

.release-candidates-table .mat-column-select {
  width: 52px;
}

.object-link-btn {
  border: 0;
  background: transparent;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: #0066b2;
  text-decoration: underline;
  cursor: pointer;
}

.object-link-btn[disabled] {
  color: #8c8f93;
  text-decoration: none;
  cursor: default;
}

.release-candidates-table .already-assigned-row .mat-mdc-cell {
  color: #8a929b;
  background: #f1f3f5;
}

.already-assigned {
  color: #7a838d;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 12px;
  text-transform: lowercase;
}

.empty-state-message {
  border: none;
  background-color: #f7f9fc;
  color: #707070;
  padding: 12px;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
}

:host ::ng-deep .mat-mdc-dialog-actions {
  border-top: 1px solid #e5e8ee;
  padding: 10px 24px 14px;
  gap: 8px;
  justify-content: flex-end;
  min-height: unset;
}

.esra-outline-btn {
  border: 1px solid #0066b2;
  background: white;
  color: #0066b2;
  min-width: 80px;
  height: 36px;
  padding: 0 12px;
  font-size: 13px;
  font-family: "GothamBold", Arial, sans-serif;
  text-transform: lowercase;
  cursor: pointer;
}

.esra-primary-btn {
  border: none;
  background-color: #0066b2;
  color: white;
  min-width: 70px;
  height: 36px;
  padding: 0 14px;
  font-size: 13px;
  text-transform: lowercase;
  cursor: pointer;
  font-family: "GothamBold", Arial, sans-serif;
}

.esra-primary-btn[disabled] {
  background-color: #8c8f93;
  cursor: not-allowed;
}

:host ::ng-deep .results-panel .mat-mdc-paginator {
  border-top: 1px solid #e5e8ee;
  background: #fafbfc;
}

:host ::ng-deep .results-panel .mat-mdc-paginator-container {
  justify-content: flex-start;
  min-height: 54px;
  padding: 4px 8px;
}

:host ::ng-deep .results-panel .mat-mdc-paginator,
:host ::ng-deep .results-panel .mat-mdc-paginator * {
  font-family: "Gotham", Arial, sans-serif;
}

@media (max-width: 1100px) {
  .dialog-title-bar h2 {
    font-size: 22px;
  }
  .content-layout {
    flex-direction: column;
  }
  .filters-column {
    width: 100%;
    max-height: none;
  }
  .release-candidates-table .mat-mdc-header-cell {
    font-size: 12px;
  }
  .release-candidates-table .mat-mdc-cell {
    font-size: 12px;
  }
  .selected-count {
    font-size: 12px;
  }
  .esra-outline-btn,
  .esra-primary-btn {
    font-size: 12px;
    min-width: 70px;
  }
}
.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
